export default "__VITE_ASSET__7e1d91f5__"